import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ProductTemplate } from 'components/Templates'

const Product: FC = () => {
  return (
    <Layout headline={'sacriで出品する商品の管理'} title={'sacriで出品する商品の管理'}>
      <ProductTemplate />
    </Layout>
  )
}

export default Product
